import { render, staticRenderFns } from "./ThgTerms.vue?vue&type=template&id=e52b3e50&scoped=true"
import script from "./ThgTerms.vue?vue&type=script&lang=ts"
export * from "./ThgTerms.vue?vue&type=script&lang=ts"
import style0 from "./ThgTerms.vue?vue&type=style&index=0&id=e52b3e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b3e50",
  null
  
)

export default component.exports